import _get from 'lodash/get'
import _set from 'lodash/set'
import _has from 'lodash/has'
import _clone from 'lodash/clone'
import _cloneDeep from 'lodash/cloneDeep'
import _isEmpty from 'lodash/isEmpty'
import _isUndefined from 'lodash/isUndefined'
import _isNumber from 'lodash/isNumber'
import Area from '../utils/area'
import Color from '../utils/color'
import store from '../store'

export default class {
  constructor () {
    this.product = {
      print_styles: []
    }
    this.fontChars = []
    this.template = 'fixed'
    this.reset = false
    this.textGraphicProperties = ['prefixGraphic', 'suffixGraphic']
    this.siliconeCustomization = {
      areas: [],
      notes: '',
      rows: [],
      printStyle: {},
      selected: 0
    }
    this.tyvekCustomization = {
      notes: '',
      rows: [],
      selected: 0,
      background: {
        color: {},
        type: '',
        pattern: '',
        selected: {
          background: {}
        },
        showBG: false
      },
      showOverlay: false,
      tracking: {
        number: false,
        barcode: false,
        startingNumber: 1
      },
      graphics: {
        images: []
      },
      phrases: {
        texts: []
      }
    }
    this.customization = this.siliconeCustomization
    this.printColorProperties = ['label', 'required', 'chargePricing']
    this.printColor = {
      'label': 'Print Color',
      'required': false,
      'chargePricing': true
    }
    this.showBuilder = true
    this.useGlobalColorFill = true
    this.isFirstPrintColorSelected = false
    this.discount = null
  }

  setProduct (ProductAssets, defaultProductPrintStyleId = null) {
    let prod = ProductAssets.product
    let layout = ProductAssets.layout

    this.customization.areas = []
    this.customization.notes = ''
    this.customization.rows = []
    this.customization.printStyle = {}
    this.customization.selected = 0
    this.defaultRow = {}
    this.product = prod
    this.layout = layout
    this.template = layout.manifest.manifest.template
    this.printedExtraColorFee = 20
    this.embossedExtraColorFee = 20

    if (layout.manifest.manifest) {
      this.product.manifest = layout.manifest.manifest
    }

    if (this.product.manifest.type === 'Dual Layer') {
      this.useGlobalColorFill = false
    }

    // Set default print style
    if (defaultProductPrintStyleId) {
      defaultProductPrintStyleId = parseInt(defaultProductPrintStyleId)
      let ps = this.getPrintStyleById(defaultProductPrintStyleId)
      if (ps) {
        this.setPrintStyle(ps)
      }
    }
    if (!this.customization.printStyle.hasOwnProperty('id')) {
      this.customization.printStyle = prod.print_styles[0]
    }

    // Initialize the Print Color object
    if (this.product.manifest.hasOwnProperty('printColor')) {
      for (let index = 0; index < this.printColorProperties.length; index++) {
        if (this.product.manifest.printColor.hasOwnProperty(this.printColorProperties[index])) {
          this.printColor[this.printColorProperties[index]] = this.product.manifest.printColor[this.printColorProperties[index]]
        }
      }
    }

    this.defaultRow = this.getDefaultRow()

    if(this.customization.rows.length < 2) {
      if (this.hasAllTheSamePrintColors()) {
        let colorConfig = Object.assign(this.getDefaultPrintColor() || {}, { _path: 'rows.0.colorFill' })
        this.defaultRow.colorFill = new Color(colorConfig)
      }
    }

    // console.log('this.defaultRow', this.defaultRow)

    this.customization.rows.push(this.defaultRow)

    // Initialize the areas
    this.populateAreas()
  }

  getTextObj (area, index) {
    area = area || 0
    return _get(this, `customization.areas.${area}.texts.${index}`, {})
  }

  /**
   * Get a print style's product pricing
   *
   * @param printStyle
   * @returns {Array}
   */
  getPrintStyleProductPricingTiers (printStyle) {
    printStyle = typeof printStyle !== 'undefined' ? printStyle : this.getPrintStyle()
    return printStyle.product_pricing_applied
  }

  getProductColors () {
    let selectedPrintStyle = this.getPrintStyle()
    return selectedPrintStyle.product_colors.colors
  }

  isColorfillTheSameAsTheBandColorOnRow (rowIndex) {
    if (typeof this.customization.rows[rowIndex] !== 'undefined') {
      let row = this.customization.rows[rowIndex]
      if (row.color1.hasOwnProperty('hex_code')) {
        let bandColorHexCode = row.color1.hex_code
        if (this.useGlobalColorFill) {
          if (row.colorFill && row.color1) {
            if (row.colorFill.hasOwnProperty('hex_code')) {
              if (row.colorFill.hex_code === bandColorHexCode) {
                return true
              }
            }
          }
        } else {
          let listOfColorFills = this.listOfPrintColors()
          for (let i = 0; i < listOfColorFills.length; i++) {
            let colorFill = listOfColorFills[i]
            if (colorFill.hasOwnProperty('hex_code')) {
              if (colorFill.hex_code === bandColorHexCode) {
                return true
              }
            }
          }
        }
      }
    }
  }

  isColorfillTheSameAsTheBandColor () {
    let valid = true
    if (!this.isMultiColor()) {
      for (let i = 0; i < this.customization.rows.length; i++) {
        if (!this.isColorfillTheSameAsTheBandColorOnRow(i)) {
          valid = false
        }
      }
    } else {
      valid = false
    }
    return valid
  }

  getPrintStyle () {
    if (this.customization.printStyle) {
      return this.customization.printStyle
    } else {
      return this.product.print_styles[0]
    }
  }

  setPrintStyle (printStyle) {
    this.customization.printStyle = printStyle
  }

  getPrintStyleById (id) {
    let index = this.product.print_styles.findIndex(function (ps) {
      return ps.id === id
    })
    return this.product.print_styles[index]
  }

  getPrintStyleCode () {
    let ps = this.getPrintStyle()
    return ps.print_style.code
  }

  /**
   * Get the currently selected variant
   */
  getVariant () {
    return this.customization.rows[this.customization.selected].variant
  }

  getVariantId () {
    let defaultVariantId = _get(this.product.variants, '0.id')
    return _get(this.customization.rows[this.customization.selected].variant, 'id', defaultVariantId)
  }

  getDefaultFont (printStyle) {
    printStyle = typeof printStyle !== 'undefined' ? printStyle : this.getPrintStyle()
    if (printStyle.font_group) {
      if (printStyle.font_group.fonts.length > 0) {
        return printStyle.font_group.fonts[0].name
      }
    }

    return null
  }

  getSelectedRow () {
    let selectedIndex = this.customization.selected
    if (typeof this.customization.rows[selectedIndex] !== 'undefined') {
      return this.customization.rows[selectedIndex]
    }
    return false
  }

  getDefaultPrintColor () {
    let style = this.getPrintStyle()
    if (style.print_colors) {
      if (style.print_colors.default_colors.length > 0) {
        return style.print_colors.default_colors[0].color
      }
    }

    // If a print color is required, and there are no default colors specified, then just return the first color in the list of print colors
    if (style.print_style.code === 'printed') {
      return style.print_colors.colors[0]
    }

    return null
  }

  getDefaultProductColors () {
    let style = this.getPrintStyle()
    if (this.isMultiColor()) {
      let colors = style.product_colors.default_colors
      // console.log('colors', colors)
      return colors.map(x => x.color)
      // return _.pluck(style.product_colors.default_colors, 'color')
    }
    return [style.product_colors.default_colors[0].color]
  }

  getPrintColors () {
    let selectedPrintStyle = this.getPrintStyle()
    return selectedPrintStyle.print_colors ? selectedPrintStyle.print_colors.colors : []
  }

  getFonts () {
    let selectedPrintStyle = this.getPrintStyle()
    return selectedPrintStyle.font_group ? selectedPrintStyle.font_group.fonts : []
  }

  getUsedFonts () {
    let fonts = []
    let isNotEmpty = true
    let texts = this.getAllTexts(isNotEmpty)
    for (let text of texts) {
      let font = _get(text, 'font')
      if (font) {
        fonts.push(font)
      }
    }

    return fonts
  }

  getMinimumOrderQuantity () {
    let selectedPrintStyle = this.getPrintStyle()
    return selectedPrintStyle.min_qty
  }

  numberOfColorContainers () {
    let num = 1
    if (this.product.manifest.colorContainers.color_1) {
      num += 1
    }
    if (this.product.manifest.colorContainers.color_2) {
      num += 1
    }
    return num
  }

  getDefaultRow () {
    let defaultProductColors = this.getDefaultProductColors()
    let rowPath = 'customization.rows.0'

    // console.log('Default Prod Colors:', defaultProductColors)
    // console.log(this.product.manifest.colorContainers)
    let obj = {}
    for (let i = 0; i < 3; i++) {
      let num = i + 1
      let colorConfig = Object.assign(defaultProductColors[i] || {}, { _path: `${rowPath}.color${num}` })
      if (i === 0) {
        obj['color' + num] = new Color(colorConfig)
      } else {
        if (this.product.manifest.colorContainers['color_' + i]) {
          obj['color' + num] = new Color(colorConfig)
        } else {
          obj['color' + num] = null
        }
      }
    }

    obj.colorFill = new Color({ _path: `${rowPath}.colorFill` })
    obj.bandType = this.product.name
    obj.variant = {}
    obj.qty = null

    // console.log('this.printColor.required', this.printColor.required)
    // console.log('this.useGlobalColorFill', this.useGlobalColorFill)
    if (this.printColor.required && this.useGlobalColorFill) {
      let colorConfig = Object.assign(this.getDefaultPrintColor() || {}, { _path: 'rows.0.colorFill' })
      obj.colorFill = new Color(colorConfig)
    }

    // console.log('Default Row:', obj)

    return obj
  }

  hasPrintColor () {
    return (this.numberOfPrintColors() > 0)
  }

  hasPrintColorInArea1 () {
    let res = this.numberOfPrintColorsPerArea()
    return _get(res, 0, false)
  }

  hasPrintColorInArea2 () {
    let res = this.numberOfPrintColorsPerArea()
    return _get(res, 1, false)
  }

  hasAnyPrintWithNoColor () {
    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            let text = this.customization.areas[i].texts[j]
            if (text.text) {
              if (text.hasOwnProperty('colorFill')) {
                if (!text.colorFill) {
                  return true
                }
              }
            }
            // Check the relational graphics
            for (let k = 0; k < this.textGraphicProperties.length; k++) {
              let graphicProp = this.textGraphicProperties[k]
              let graphicImage = _get(text, `${graphicProp}.image`, null)
              if (graphicImage) {
                let graphicColorFill = _get(text, `${graphicProp}.colorFill.id`, null)
                if (!graphicColorFill) {
                  return true
                }
              }
            }
          }
        }

        // Check the fixed graphics
        if (this.customization.areas[i].hasOwnProperty('graphics')) {
          for (let z = 0; z < this.customization.areas[i].graphics.length; z++) {
            if (this.customization.areas[i].graphics[z].image) {
              if (this.customization.areas[i].graphics[z].hasOwnProperty('colorFill')) {
                if (!this.customization.areas[i].graphics[z].colorFill) {
                  return true
                }
              }
            }
          }
        }
      }
    }

    return false
  }

  isMultiColor () {
    if (!this.isEmptyObject(this.product.manifest.colorContainers) && (this.product.manifest.type !== 'Dual Layer')) {
      return !this.isEmptyObject(this.product.manifest.colorContainers)
    } else {
      return false
    }
  }

  isEmptyObject (obj) {
    if (obj !== null && typeof obj === 'object') {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
    }

    return true
  }

  isTyvek () {
    return this.template === 'free'
  }

  isDualLayer () {
    return this.product.manifest.type === 'Dual Layer'
  }

  isPrinted () {
    return this.getPrintStyleCode() === 'printed'
  }

  isEmbossed () {
    return this.getPrintStyleCode() === 'embossed'
  }

  isBlank () {
    return this.getPrintStyleCode() === 'blank'
  }

  clearAllPrintAreas () {
    let i, j

    for (i = 0; i < this.customization.areas.length; i++) {
      if (this.customization.areas[i].hasOwnProperty('texts')) {
        for (j = 0; j < this.customization.areas[i].texts.length; j++) {
          let text = this.customization.areas[i].texts[j]

          // Clear phrase
          if (text.hasOwnProperty('text')) {
            text.text = ''
          }

          // Clear all relational graphics
          for (let k = 0; k < this.textGraphicProperties.length; k++) {
            let textGraphicProperty = this.textGraphicProperties[k]
            let textGraphicImage = _get(text, `${textGraphicProperty}.image`, false)
            if (textGraphicImage) {
              text[textGraphicProperty].image = ''
            }
          }
        }
      }

      // Check the fixed graphics
      if (this.customization.areas[i].hasOwnProperty('graphics')) {
        for (let z = 0; z < this.customization.areas[i].graphics.length; z++) {
          let graphic = this.customization.areas[i].graphics[z]
          if (graphic.hasOwnProperty('image')) {
            graphic.image = ''
          }
        }
      }
    }
  }

  getAllTexts (isNotEmpty = false) {
    let texts = []
    for (let area of this.customization.areas) {
      for (let text of area.texts) {
        if (isNotEmpty) {
          if (_get(text, 'text', false)) {
            texts.push(text)
          }
        } else {
          texts.push(text)
        }
      }
    }
    return texts
  }

  getAllGraphicsText (isNotEmpty = false) {
    let textGraphics = []

    let texts = this.getAllTexts()
    // console.log('texts', texts)
    for (let text of texts) {
      for (let textGraphicProp of this.textGraphicProperties) {
        if (text.hasOwnProperty(textGraphicProp)) {
          if (isNotEmpty) {
            if (_get(text[textGraphicProp], 'image', false)) {
              textGraphics.push(text[textGraphicProp])
            }
          } else {
            textGraphics.push(text[textGraphicProp])
          }
        }
      }
    }

    return textGraphics
  }

  getAllGraphicsFixed (isNotEmpty = false) {
    let fixedGraphics = []

    for (let area of this.customization.areas) {
      for (let graphic of area.graphics) {
        if (isNotEmpty) {
          if (_get(graphic, 'image', false)) {
            fixedGraphics.push(graphic)
          }
        } else {
          fixedGraphics.push(graphic)
        }
      }
    }

    return fixedGraphics
  }

  getAllGraphics (isNotEmpty = false) {
    let textGraphics = this.getAllGraphicsText(isNotEmpty)
    let fixedGraphics = this.getAllGraphicsFixed(isNotEmpty)

    // console.log('isNotEmpty', isNotEmpty)
    // console.log('textGraphics', textGraphics)
    // console.log('fixedGraphics', fixedGraphics)

    return textGraphics.concat(fixedGraphics)
  }

  getAllTextsAndGraphics (isNotEmpty = false) {
    let texts = this.getAllTexts(isNotEmpty)
    let graphics = this.getAllGraphics(isNotEmpty)
    return texts.concat(graphics)
  }

  hasSerial () {
    if (typeof this.customization.tracking !== 'undefined') {
      return this.customization.tracking.number
    }
    return false
  }

  hasBackPhrase () {
    return this.numberOfTexts() > 1
  }

  hasTexts () {
    return this.numberOfTexts() > 0
  }

  hasBarcode () {
    if (typeof this.customization.tracking !== 'undefined') {
      return this.customization.tracking.barcode
    }
    return false
  }

  numberOfExistingPhrases () {
    let numberOfExistingPhrases = 0
    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            if (this.customization.areas[i].texts[j].hasOwnProperty('text')) {
              if (this.customization.areas[i].texts[j].text.length) {
                numberOfExistingPhrases += 1
              }
            }
          }
        }
      }
    }
    return numberOfExistingPhrases
  }

  hasExtraPhrase () {
    let hasExtraPhrase = false
    let numberOfExistingPhrases = this.numberOfExistingPhrases()
    let graphics = this.getAllGraphicsText(true)

    if (numberOfExistingPhrases > 1) {
      hasExtraPhrase = true
    }

    if (graphics) {
      if (graphics.some(g => g.areaIndex > 0)) {
        hasExtraPhrase = true
      }
    }

    return hasExtraPhrase
  }

  setAllPrintColors (color) {
    let allTextAndGraphics = this.getAllTextsAndGraphics()
    for (let obj of allTextAndGraphics) {
      let manifestColorFill = _get(obj, 'manifest.colorFill', false)
      if (manifestColorFill) {
        this.setPathValue(`${obj._path}.colorFill`, color)
      }
    }
  }

  setColor (obj) {
    this.setPathValue(obj._path, obj)
  }

  setPathValue (path, value) {
    if (_has(this, path)) {
      _set(this, path, value)
    } else {
      console.log(`setPathValue: Path (${path}) does not exist. Value:`, value)
      // console.log('customization:', this.customization)
    }
  }

  setFont (obj, fontName) {
    this.setPathValue(`${obj._path}.font`, fontName)
  }

  setText (obj, text) {
    this.setPathValue(`${obj._path}.text`, text)
  }

  setVariant (rowIndex, variant) {
    this.setPathValue(`customization.rows.${rowIndex}.variant`, variant)
  }

  clearAllGlobalPrintColors () {
    for (let row of this.customization.rows) {
      row.colorFill = {}
    }
  }

  setAllGlobalPrintColors (color) {
    for (let row of this.customization.rows) {
      row.colorFill = color
    }
  }

  /**
   * Set the global print color
   *    NOTE: The global print color is only allowed when all the print colors are the same
   *
   * @param color
   */
  setGlobalPrintColor (color, index) {
    let row = this.customization.rows[index]
    row.colorFill = color
  }

  getGlobalPrintColor () {
    let selectedRow = this.getSelectedRow()
    return selectedRow.colorFill
  }

  getGlobalPrintColorId () {
    let printColor = this.getGlobalPrintColor()
    return _get(printColor, 'id')
  }

  getGlobalPrintColorHex () {
    let printColor = this.getGlobalPrintColor()
    let printColorId = this.getGlobalPrintColorId()
    if (printColorId) {
      return '#' + _get(printColor, 'hex_code')
    } else {
      return null
    }
  }

  removeGlobalPrintColor () {
    this.customization.rows[0].colorFill = new Color({ _path: 'customization.rows.0.colorFill' })
  }

  hasMultipleItems () {
    return this.customization.rows.length > 1
  }

  /**
   * Returns the color fill tiers of a PricingGroup based on how many colors
   *      are currently selected
   *
   * @returns {*}
   */
  getPrintColorPricingTiers (area = 0) {
    let selectedPrintStyle = this.getPrintStyle()
    let pricingFieldName = 'print_color_pricing'
    if (area > 0) {
      pricingFieldName += `_${area + 1}`
    }

    // If the selected style has print color pricing
    //  NOTE: The "printed" style WILL have multiple print colors but WON'T have print color pricing
    if (selectedPrintStyle[pricingFieldName].length) {
      return selectedPrintStyle[pricingFieldName][0].tiers
    }
  }

  /**
   * Returns the color fill tiers of a PricingGroup based on how many colors
   *      are currently selected
   *
   * @returns {*}
   */
  getPrintColorPricing2Tiers () {
    let selectedPrintStyle = this.getPrintStyle()

    // If the selected style has print color pricing
    //  NOTE: The "printed" style WILL have multiple print colors but WON'T have print color pricing
    if (selectedPrintStyle.print_color_pricing.length) {
      return selectedPrintStyle.print_color_pricing_2[0].tiers
    }
  }

  getProductPricingTiers () {
    return this.product.pricing[0].tiers
  }

  getExtraPhrasePricingTiers () {
    return this.product.phrase[0].tiers
  }

  getCustomArtPricingTiers () {
    return this.product.custom_art[0].tiers
  }

  getTyvekSerialPricingTiers () {
    return this.product.serial[0].tiers
  }

  getTyvekBarcodePricingTiers () {
    return this.product.barcode[0].tiers
  }

  /**
   * Apply a pricing tier to the original pricing tier
   *  NOTE: NOT CURRENTLY BEING USED.  ISSUES IN ANGULAR WITH INFINITE LOOPS
   *  NOTE: Tiers need to be sorted by min qty first
   *
   * @param tier1
   * @param tier2
   * @returns {Array}
   */
  applyPricingTier (tier1, tier2) {
    if (!Array.isArray(tier1) || !Array.isArray(tier2)) {
      throw new Error('Both parameters must be an array to apply pricing tiers')
    }
    if (tier2.length) {
      let newTiers = []
      for (let i = 0; i < tier1.length; i++) {
        let tier = tier1[i]
        let newTier = tier
        if (typeof tier2[i] !== 'undefined') {
          if (tier2[i].min === tier.min && tier2[i].max === tier.max) {
            let price = Number(tier.price)
            price += Number(tier2[i])
            newTier.price = price
          }
        }
        newTiers.push(newTier)
      }
      return newTiers
    } else {
      return tier1
    }
  }

  isSwearWords (value) {
    let re = /fuck|shit|bitch|asshole/i

    if (value !== '' && value !== undefined) {
      return re.test(value)
    }

    return false
  }

  isValidPhrases (commit) {
    let category = 'valid_phrases'
    let msg = 'No swear words are allowed'

    const emojiRegex = require('emoji-regex')
    const regex = emojiRegex();

    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            if (this.customization.areas[i].texts[j].hasOwnProperty('text')) {
              if (this.isSwearWords(this.customization.areas[i].texts[j].text)) {
                this.addAlert(commit, category, msg)
                return false
              }
            }
          }
        }
      }
    } else {
      if (this.customization.hasOwnProperty('phrases')) {
        if (this.customization.phrases.hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.phrases.texts.length; j++) {
            let textObj = this.customization.phrases.texts[j]
            if (this.isSwearWords(textObj.text)) {
              this.addAlert(commit, category, msg)
              return false
            }
          }
        }
      }
    }

    msg = 'Please shorten your phrase'
    let texts = this.getAllTexts()
    for (let textObj of texts) {
      let maxChars = _get(textObj, 'manifest.maxCharacters')
      if (maxChars) {
        if (textObj.text.length > maxChars) {
          this.addAlert(commit, category, msg)
          return false
        }
      }
    }

    msg = 'No emojis allowed. Please use art instead.'
    for (let textObj of texts) {
      if (regex.exec(textObj.text)) {
        this.addAlert(commit, category, msg)
        return false
      }
    }

    this.removeAlert(commit, category)

    return true
  }

  isValid (commit) {
    return this.isValidPhrases(commit)
  }

  setGraphicImage (obj, image) {
    this.setPathValue(`${obj._path}.image`, image)
  }

  setGraphicCustom (obj, isCustom) {
    this.setPathValue(`${obj._path}.custom`, isCustom)
  }

  resetGraphic () {
    delete this.id
    delete this.image
    delete this.name
  }

  updateGraphicWithArt (art) {
    this.id = art.id
    this.image = art.image
    this.name = art.name
  }

  getRelationalGraphics () {
    let graphics = []
    for (let i = 0; i < this.customization.areas.length; i++) {
      if (this.customization.areas[i].hasOwnProperty('texts')) {
        for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
          let text = this.customization.areas[i].texts[j]
          for (let k = 0; k < this.textGraphicProperties.length; k++) {
            if (text.hasOwnProperty(this.textGraphicProperties[k])) {
              graphics.push(text[this.textGraphicProperties[k]])
            }
          }
        }
      }
    }
    return graphics
  }

  hasRelationalGraphics () {
    for (let i = 0; i < this.customization.areas.length; i++) {
      if (this.customization.areas[i].hasOwnProperty('texts')) {
        for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
          let text = this.customization.areas[i].texts[j]
          if (text.hasOwnProperty('prefixGraphic') || text.hasOwnProperty('suffixGraphic')) {
            return true
          }
        }
      }
    }
    return false
  }

  getFixedGraphics () {
    let graphics = []
    for (let i = 0; i < this.customization.areas.length; i++) {
      if (this.customization.areas[i].hasOwnProperty('graphics')) {
        for (let j = 0; j < this.customization.areas[i].graphics.length; j++) {
          graphics.push(this.customization.areas[i].graphics[j])
        }
      }
    }
    return graphics
  }

  hasFixedGraphics () {
    for (let i = 0; i < this.customization.areas.length; i++) {
      if (this.customization.areas[i].hasOwnProperty('graphics')) {
        return !!this.customization.areas[i].graphics.length
      }
    }
    return false
  }

  getFixedGraphicAt (areasIndex, graphicIndex) {
    return _get(this, `customization.areas.${areasIndex}.graphics.${graphicIndex}`, false)
  }

  graphicsAreValid (commit) {
    let graphics = this.getGraphics()
    let category = 'upload_custom_graphic'

    // console.log('graphics', graphics)

    for (const graphic of graphics) {
      let graphicCustom = _get(graphic, 'custom', null)
      let graphicImage = _get(graphic, 'image', null)
      if (graphicCustom && !graphicImage) {
        let msg = 'Please upload a custom graphic'
        this.addAlert(commit, category, msg)
      } else {
        this.removeAlert(commit, category)
      }
    }
    return true
  }

  getGraphics () {
    let graphics = []
    for (const area of this.customization.areas) {
      if (area.hasOwnProperty('texts')) {
        for (const text of area.texts) {
          for (const graphicProperty of this.textGraphicProperties) {
            if (text.hasOwnProperty(graphicProperty)) {
              if (text[graphicProperty]) {
                graphics.push(text[graphicProperty])
              }
            }
          }
        }
      }
      if (area.hasOwnProperty('graphics')) {
        for (const graphic of area.graphics) {
          if (graphic) {
            graphics.push(graphic)
          }
        }
      }
    }

    return graphics
  }

  getSelectedGraphics () {
    let selectedGraphics = []
    for (const area of this.customization.areas) {
      let texts = _get(area, 'texts', [])
      for (const text of texts) {
        for (const graphicProperty of this.textGraphicProperties) {
          let textGraphic = _get(text, graphicProperty)
          if (textGraphic) {
            let img = _get(textGraphic, 'image')
            if (img) {
              selectedGraphics.push(textGraphic)
            }
          }
        }
      }
      let graphics = _get(area, 'graphics', [])
      for (const graphic of graphics) {
        let img = _get(graphic, 'image')
        if (img) {
          selectedGraphics.push(graphic)
        }
      }
    }
    return selectedGraphics
  }

  getUniqueGraphics (graphics) {
    let uniqueGraphics = []
    let seenGraphics = []
    for (const graphic of graphics) {
      let img = _get(graphic, 'image')
      if (img) {
        if (!seenGraphics.includes(img)) {
          seenGraphics.push(img)
          uniqueGraphics.push(graphic)
        }
      }
    }
    return uniqueGraphics
  }

  hasGraphics () {
    if (this.template !== 'free') {
      return this.hasRelationalGraphics() || this.hasFixedGraphics()
    } else {
      if (this.customization.hasOwnProperty('graphics')) {
        if (this.customization.graphics.hasOwnProperty('images')) {
          if (this.customization.graphics.images.length > 0) {
            return true
          }
        }
      }
      return false
    }
  }

  hasCustomGraphic () {
    if (this.template !== 'free') {
      let graphics = this.getGraphics()
      for (let i = 0; i < graphics.length; i++) {
        let graphic = graphics[i]
        if (graphic.hasOwnProperty('custom')) {
          if (graphic.custom) {
            return true
          }
        }
      }
    } else {

    }
    return false
  }

  isCustomColor (commit) {
    let isCustomColor = false
    try {
      isCustomColor = this.product.manifest.type === 'Custom Color'
    } catch (e) {}

    this.removeWarning(commit, 'custom_color')
    if (isCustomColor) {
      let msg = 'Please enter your custom pantone number on the last step in the notes to customer service'
      this.addWarning(commit, 'custom_color', msg)
      return false
    } else {
      return true
    }
  }

  numberOfTexts () {
    let i
    let total = 0
    if (this.template !== 'free') {
      for (i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          total += 1
        }
      }
    } else {
      if (this.customization.hasOwnProperty('phrases')) {
        if (this.customization.phrases.hasOwnProperty('texts')) {
          total++
        }
      }
    }

    return total
  }

  numberOfExtraPrintColors () {
    return Math.max(0, this.numberOfPrintColors() - 1)
  }

  numberOfSizes () {
    let uniqueSizes = []
    for (let row of this.customization.rows) {
      if (!uniqueSizes.includes(row.variant.id)) {
        uniqueSizes.push(row.variant.id)
      }
    }
    // console.log('uniqueSizes.length', uniqueSizes.length);
    return uniqueSizes.length
  }

  listOfPrintColors () {
    let listOfColorFills = []
    let colorsUsed = []
    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            let text = this.customization.areas[i].texts[j]
            if (text.text) {
              let colorFillId = _get(text, 'colorFill.id')
              let colorFillHex = _get(text, 'colorFill.hex_code')
              if (colorFillId) {
                if (colorsUsed.indexOf(colorFillHex) === -1) {
                  listOfColorFills.push(text.colorFill)
                  colorsUsed.push(colorFillHex)
                }
              }
            }
            // Check the relational graphics
            for (let k = 0; k < this.textGraphicProperties.length; k++) {
              let graphic = _get(text, this.textGraphicProperties[k])
              let graphicImage = _get(graphic, 'image')
              let graphicColorFill = _get(graphic, 'colorFill')
              let graphicColorFillId = _get(graphicColorFill, 'id')
              let graphicColorFillHexCode = _get(graphicColorFill, 'hex_code')
              if (graphicImage && graphicColorFillId) {
                if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                  listOfColorFills.push(graphicColorFill)
                  colorsUsed.push(graphicColorFillHexCode)
                }
              }
            }
          }
        }

        // Check the fixed graphics
        if (this.customization.areas[i].hasOwnProperty('graphics')) {
          for (let z = 0; z < this.customization.areas[i].graphics.length; z++) {
            let graphic = this.customization.areas[i].graphics[z]
            if (graphic.image) {
              let graphicColorFill = _get(graphic, 'colorFill')
              let graphicColorFillId = _get(graphicColorFill, 'id')
              let graphicColorFillHexCode = _get(graphicColorFill, 'hex_code')
              if (graphicColorFillId) {
                if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                  listOfColorFills.push(graphicColorFill)
                  colorsUsed.push(graphicColorFillHexCode)
                }
              }
            }
          }
        }
      }
    }

    return listOfColorFills
  }

  /**
   * Return an array of the number of colors per area
   *
   * @returns {Array}
   */
  numberOfPrintColorsPerArea (sum) {
    sum = typeof sum !== 'undefined' ? sum : false
    let colorsPerArea = []
    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        let colorsUsed = []
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            let text = this.customization.areas[i].texts[j]
            if (text.text) {
              let colorFillId = _get(text, 'colorFill.id')
              let hexCode = _get(text, 'colorFill.hex_code')
              if (colorFillId && hexCode) {
                if (colorsUsed.indexOf(hexCode) === -1) {
                  colorsUsed.push(hexCode)
                }
              }
            }
            // Check the relational graphics
            for (let k = 0; k < this.textGraphicProperties.length; k++) {
              let graphicProp = this.textGraphicProperties[k]
              let graphic = _get(text, graphicProp)
              let graphicColorFill = _get(graphic, 'colorFill')
              let graphicColorFillHexCode = _get(graphicColorFill, 'hex_code')
              let graphicImage = _get(graphic, 'image')

              if (graphicImage) {
                if (graphicColorFillHexCode) {
                  if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                    colorsUsed.push(graphicColorFillHexCode)
                  }
                }
              }
            }
          }
        }

        // Check the fixed graphics
        if (this.customization.areas[i].hasOwnProperty('graphics')) {
          for (let z = 0; z < this.customization.areas[i].graphics.length; z++) {
            let graphic = this.customization.areas[i].graphics[z]
            let graphicColorFill = _get(graphic, 'colorFill')
            let graphicColorFillHexCode = _get(graphicColorFill, 'hex_code')
            let graphicImage = _get(graphic, 'image')
            if (graphicImage) {
              if (graphicColorFillHexCode) {
                if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                  colorsUsed.push(graphicColorFillHexCode)
                }
              }
            }
          }
        }
        // console.log('colorsUsed', colorsUsed)
        colorsPerArea.push(colorsUsed.length)
      }
    }

    // console.log('colorsPerArea', colorsPerArea)
    if (sum) {
      return colorsPerArea.reduce((a, b) => {
        return a + b
      }, 0)
    }

    return colorsPerArea
  }

  getSelectedPrintColorHexCodes (isNotEmpty = false) {
    let hexCodes = []
    let colors = this.getSelectedPrintColors(isNotEmpty)
    for (let color of colors) {
      hexCodes.push(`#${color.hex_code}`)
    }

    return hexCodes
  }

  getSelectedPrintColors (isNotEmpty = false) {
    let printColors = []
    let allObjects = this.getAllTextsAndGraphics(isNotEmpty)
    for (let obj of allObjects) {
      let colorFill = _get(obj, 'colorFill')
      if (colorFill) {
        printColors.push(colorFill)
      }
    }

    return printColors
  }

  numberOfPrintColors () {
    let colorsUsed = []
    if (this.template !== 'free') {
      for (let i = 0; i < this.customization.areas.length; i++) {
        if (this.customization.areas[i].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[i].texts.length; j++) {
            let text = this.customization.areas[i].texts[j]

            if (text.text) {
              let textColorFillHexCode = _get(text, 'colorFill.hex_code', null)
              if (textColorFillHexCode) {
                if (colorsUsed.indexOf(textColorFillHexCode) === -1) {
                  colorsUsed.push(textColorFillHexCode)
                }
              }
            }
            // Check the relational graphics
            for (let k = 0; k < this.textGraphicProperties.length; k++) {
              let graphicProp = this.textGraphicProperties[k]
              let graphicImage = _get(text, `${graphicProp}.image`)
              let graphicColorFillHexCode = _get(text, `${graphicProp}.colorFill.hex_code`, null)
              if (graphicImage && graphicColorFillHexCode) {
                if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                  colorsUsed.push(graphicColorFillHexCode)
                }
              }
            }
          }
        }

        // Check the fixed graphics
        if (this.customization.areas[i].hasOwnProperty('graphics')) {
          for (let z = 0; z < this.customization.areas[i].graphics.length; z++) {
            let graphic = this.customization.areas[i].graphics[z]
            let graphicImage = _get(graphic, 'image')
            let graphicColorFillHexCode = _get(graphic, 'colorFill.hex_code', null)
            if (graphicImage && graphicColorFillHexCode) {
              if (colorsUsed.indexOf(graphicColorFillHexCode) === -1) {
                colorsUsed.push(graphicColorFillHexCode)
              }
            }
          }
        }
      }
    }

    return colorsUsed.length
  }

  maxPrintColors () {
    let code = this.getPrintStyleCode()
    if (code === 'debossed') {
      return 2
    } else if (code === 'printed') {
      return 1
    } else if (code === 'embossed') {
      return 1
    } else {
      return 2
    }
  }

  getMaxPrintColorsPerArea () {
    return Math.max.apply(null, this.numberOfPrintColorsPerArea())
  }

  isOverMaxPrintColors () {
    let printStyleCode = this.getPrintStyleCode()
    let maxColors = this.maxPrintColors()
    let numOfPrintColors = this.numberOfPrintColors()
    if (printStyleCode === 'debossed') {
      // return this.getMaxPrintColorsPerArea() > maxColors
      return numOfPrintColors > maxColors
    } else if (printStyleCode === 'embossed') {
      return numOfPrintColors > maxColors
    } else if (printStyleCode === 'printed') {
      return numOfPrintColors > maxColors
    }
    return false
  }

  isOverMaxPrintColorsMessage () {
    let perArea = ''
    let printStyleCode = this.getPrintStyleCode()
    // if (printStyleCode === 'debossed') {
    //   perArea = ' per side'
    // }

    if (printStyleCode === 'embossed') {
      return 'A maximum of ' + this.maxPrintColors() + ' print colors are allowed' + perArea + ' for embossed.  For additional print colors, choose a different imprint style.'
    }
    return 'A maximum of ' + this.maxPrintColors() + ' different print colors are allowed' + perArea + '.  You have ' + this.numberOfPrintColors()
  }

  /**
   * Get the total quantity
   *
   * @returns {number}
   */
  getTotalQuantity () {
    let qty = 0
    for (let row of this.customization.rows) {
      if (row.hasOwnProperty('qty')) {
        if (row.qty && !isNaN(parseInt(row.qty))) {
          qty += parseInt(row.qty)
        }
      }
    }

    return qty
  }

  /**
   * Get the price from a list of tiers
   *
   * @param tiers
   * @param qty
   * @returns {number}
   */
  getPriceFromTier (tiers, qty) {
    if (!Array.isArray(tiers)) {
      throw new TypeError('tiers is not an array')
    }

    let tiersSorted = _clone(tiers)

    // Sort the tiers by minimum quantity ascending
    tiersSorted.sort(function (a, b) {
      return a.min - b.min
    })

    for (let tier of tiersSorted) {
      if (qty >= tier.min && qty <= tier.max) {
        return Number(tier.price)
      }
    }
    return 0
  }

  /**
   * Get the product's price based on the qty
   *
   * @returns {number}
   */
  getProductPrice (qty) {
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    let tiers = this.getProductPricingTiers()
    return this.getPriceFromTier(tiers, qty)
  }

  /**
   * Get the current print style product price
   *
   * @param printStyle
   * @param qty
   * @returns {*|number}
   */
  getPrintStyleProductPrice (printStyle, qty) {
    printStyle = typeof printStyle !== 'undefined' ? printStyle : this.getPrintStyle()
    let tiers = _get(printStyle, 'product_pricing.0.tiers', [])
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    return this.getPriceFromTier(tiers, qty)
  }

  /**
   * Get the current print style print color price
   *
   * @param printStyle
   * @param qty
   * @returns {*|number}
   */
  getPrintStylePrintColorPrice (printStyle, qty) {
    let printColorPrice = 0
    let tiers = []
    printStyle = typeof printStyle !== 'undefined' ? printStyle : this.getPrintStyle()
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    let numberOfPrintColors = this.hasPrintColorInArea1()
    if (numberOfPrintColors > 0) {
      if (printStyle.print_color_pricing.length > 0) {
        // Determine which product group we need (the first)
        tiers = printStyle.print_color_pricing[0].tiers
        let tieredPrice = this.getPriceFromTier(tiers, qty)

        // Determine the algorithm to use based on print style
        if (['debossed', 'embossed'].indexOf(printStyle.print_style.code) >= 0) {
          let printColorPriceAddOn = (RB.extra_print_color_fee * Math.max((numberOfPrintColors - 1), 0)).toFixed(2)
          printColorPrice = Number(tieredPrice) + Number(printColorPriceAddOn)
        } else if (printStyle.print_style.code === 'embossed') {

        }
      }
    }

    return Number(printColorPrice)
  }

  /**
   * Get the current print style print color price for side 2
   *
   * @param printStyle
   * @param qty
   * @returns {*|number}
   */
  getPrintStylePrintColorPrice2 (printStyle, qty) {
    let printColorPrice = 0
    let tiers = []
    printStyle = typeof printStyle !== 'undefined' ? printStyle : this.getPrintStyle()
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    let numberOfPrintColors = this.hasPrintColorInArea2()
    if (this.hasPrintColorInArea2()) {
      if (printStyle.print_color_pricing_2.length > 0) {
        // Determine which product group we need (the first)
        tiers = printStyle.print_color_pricing_2[0].tiers
        let tieredPrice = this.getPriceFromTier(tiers, qty)

        // Determine the algorithm to use based on print style
        if (['debossed', 'embossed'].indexOf(printStyle.print_style.code) >= 0) {
          let printColorPriceAddOn = (RB.extra_print_color_fee * Math.max((numberOfPrintColors - 1), 0)).toFixed(2)
          printColorPrice = Number(tieredPrice) + Number(printColorPriceAddOn)
        } else if (printStyle.print_style.code === 'embossed') {

        }
      }
    }

    return Number(printColorPrice)
  }

  /**
   * Get the price modifier for a variant
   *
   * @param variant
   * @param qty
   * @returns {*|number}
   */
  getVariantPrice (variant, qty) {
    variant = typeof variant !== 'undefined' ? variant : this.getVariant()
    let tiers = _get(variant, 'pricing.0.tiers', [])
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    return this.getPriceFromTier(tiers, qty)
  }

  /**
   * Get the price modifier for an extra phrase
   *
   * @param qty
   * @returns {*|number}
   */
  getExtraPhrasePrice (qty) {
    let tiers = []
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    if (this.hasExtraPhrase()) {
      tiers = this.getExtraPhrasePricingTiers()
    }
    return this.getPriceFromTier(tiers, qty)
  }

  getPrintedExtraColorPrice () {
    if (this.isPrinted()) {
      let totalColorsPerArea = this.numberOfPrintColors()
      let extraColors = Math.max(totalColorsPerArea - 1, 0)
      return extraColors * this.printedExtraColorFee
    }
    return 0
  }

  getEmbossedExtraColorPrice () {
    if (this.isEmbossed()) {
      let totalColorsPerArea = this.numberOfPrintColors()
      let extraColors = Math.max(totalColorsPerArea, 0)
      return extraColors * this.embossedExtraColorFee
    }
    return 0
  }

  getCustomArtPrice (qty) {
    let tiers = []
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    if (this.hasCustomGraphic()) {
      tiers = this.getCustomArtPricingTiers()
    }
    return this.getPriceFromTier(tiers, qty)
  }

  getTyvekSerialPrice (qty) {
    let tiers = []
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    if (this.hasSerial()) {
      tiers = this.getTyvekSerialPricingTiers()
    }
    return this.getPriceFromTier(tiers, qty)
  }

  getTyvekBarcodePrice (qty) {
    let tiers = []
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()
    if (this.hasBarcode()) {
      tiers = this.getTyvekBarcodePricingTiers()
    }
    return this.getPriceFromTier(tiers, qty)
  }

  /**
   * Everything minus the fees
   *
   * @param qty
   * @param variant
   */
  getBasePricePerBand (qty, variant) {
    qty = typeof qty !== 'undefined' ? qty : this.getTotalQuantity()

    let productPricePerBand = this.getProductPrice(qty)
    let printStyleProductPricePerBand = this.getPrintStyleProductPrice(undefined, qty)
    let variantPricePerBand = this.getVariantPrice(variant, qty)
    let pricePerBand = productPricePerBand + printStyleProductPricePerBand + variantPricePerBand

    // Check to see if there is a discount
    if (this.discount) {
      let percent = this.discount.percent
      let discountMax = _get(this.discount, 'max_quantity')
      let pricePerBandToUseForDiscount = pricePerBand

      if (discountMax > 0) {
        if (qty >= discountMax) {
          let tiers = this.getPrintStyleProductPricingTiers()
          let tiersSorted = _clone(tiers)

          // Sort the tiers by minimum quantity ascending
          tiersSorted.sort(function (a, b) {
            return a.min - b.min
          })

          let lowestPrice = 9999
          for (let tier of tiersSorted) {
            if (tier.max < discountMax) {
              if (lowestPrice > tier.price) {
                lowestPrice = Number(tier.price)
              }
            }
          }

          pricePerBandToUseForDiscount = lowestPrice
        }
      }

      // console.log('pricePerBandToUseForDiscount', pricePerBandToUseForDiscount)
      let discount = pricePerBandToUseForDiscount * (percent / 100)
      pricePerBand = pricePerBandToUseForDiscount - discount.toFixed(2)
    }

    pricePerBand = Number(pricePerBand)
    pricePerBand = Number(pricePerBand.toFixed(2))
    return pricePerBand
  }

  getPricePerBand (qty, variant) {
    // Get the product's price per band
    let pricePerBand = 0

    // Base the price off the total quantity so they get the price discounts
    let totalQty = this.getTotalQuantity()

    // Now get the price modifiers
    // let productPricePerBand = this.getProductPrice(totalQty)
    // let printStyleProductPricePerBand = this.getPrintStyleProductPrice(undefined, totalQty)
    // let variantPricePerBand = this.getVariantPrice(variant, totalQty)
    let basePricePerBand = this.getBasePricePerBand(totalQty, variant)
    pricePerBand += basePricePerBand

    // Fees
    let printStylePrintColorPricePerBand = this.getPrintStylePrintColorPrice(undefined, totalQty)
    let printStylePrintColorPrice2PerBand = this.getPrintStylePrintColorPrice2(undefined, totalQty)
    let extraPhraseFee = this.getExtraPhrasePrice(totalQty)
    let customArtFee = this.getCustomArtPrice(totalQty)
    let serialFee = this.getTyvekSerialPrice(totalQty)
    let barcodeFee = this.getTyvekBarcodePrice(totalQty)
    if (barcodeFee > 0) {
      serialFee = 0
    }

    pricePerBand += printStylePrintColorPricePerBand + printStylePrintColorPrice2PerBand + extraPhraseFee + customArtFee + serialFee + barcodeFee
    pricePerBand = Number(pricePerBand.toFixed(2))

    // console.group('Prices')
    // console.log('basePricePerBand', basePricePerBand)
    // console.log('printStylePrintColorPricePerBand', printStylePrintColorPricePerBand)
    // console.log('printStylePrintColorPrice2PerBand', printStylePrintColorPrice2PerBand)
    // console.log('variantPricePerBand', variantPricePerBand)
    // console.log('extraPhraseFee', extraPhraseFee)
    // console.log('customArtFee', customArtFee)
    // console.log('serialFee', serialFee)
    // console.log('barcodeFee', barcodeFee)
    // console.log('pricePerBand', pricePerBand)
    // console.groupEnd()

    return Number((pricePerBand * qty).toFixed(2))
  }

  /**
   * These are all other fees not based on a price per band
   */
  getOtherFees () {
    let totalOtherFees = 0

    let printedExtraColorFee = this.getPrintedExtraColorPrice()
    let embossedExtraColorFee = this.getEmbossedExtraColorPrice()

    totalOtherFees += printedExtraColorFee + embossedExtraColorFee
    return Number(totalOtherFees.toFixed(2))
  }

  validateNotes (commit) {
    let valid = true
    let category = 'notes'

    this.removeAlert(commit, category)

    if (this.product.manifest.notes && this.product.manifest.notes.required && !this.customization.notes) {
      this.addAlert(commit, category, 'Some notes to customer service are required for your band')
      valid = false
    }
    return valid
  }

  validateOrderRows (commit) {
    let valid = true
    let numOfColorContainers = this.numberOfColorContainers()

    this.removeAlert(commit, 'choose_size')
    this.removeAlert(commit, 'qty')
    this.removeAlert(commit, 'minimum_qty')
    this.removeAlert(commit, 'select_color')
    this.removeAlert(commit, 'recommend_colorfill')

    for (let row of this.customization.rows) {
      let qty = parseInt(row.qty)
      if (_isEmpty(row.variant)) {
        // console.log('row.variant', row.variant)
        let msg = 'Please choose a size'
        this.addAlert(commit, 'choose_size', msg)
        valid = false
      } else if (isNaN(qty) || !_isNumber(qty) || qty < 1) {
        this.addAlert(commit, 'qty', 'Please enter a valid quantity')
        valid = false
      } else if (this.product.manifest.minQuantity && qty < this.product.manifest.minQuantity) {
        let msg = `You must order a minimum of ${this.product.manifest.minQuantity} bands per band variation`
        this.addAlert(commit, 'minimum_qty', msg)
        valid = false
      } else {
        // DisplayAlert.remove(['choose_size', 'qty', 'minimum_qty'])
      }

      // Validate colors
      let allColorsAreGood = true
      let colorMsg
      for (let i = 1; i <= numOfColorContainers; i++) {
        if (this.product.manifest.type !== 'Dual Layer') {
          // Make sure they've selected all colors
          if (!row['color' + i]) {
            if (numOfColorContainers > 1) {
              colorMsg = 'Please select the colors you would like'
            } else {
              colorMsg = 'Please select a color'
            }
            allColorsAreGood = false
            valid = false
          }
        }
      }
      if (!allColorsAreGood) {
        this.addAlert(commit, 'select_color', colorMsg)
      } else {
        this.removeAlert(commit, 'select_color')
      }

      // Warn about certain colors that need colorfill
      this.removeWarning(commit, 'recommend_colorfill')
      let hasPrintColor = this.hasPrintColor()
      for (var i = 1; i <= 3; i++) {
        let recommendCF = _get(row, `color${i}.recommend_colorfill`)
        if (recommendCF && !hasPrintColor) {
          let msg = 'The phrase on this color of band will be hard to see if you do not select a Print Color'
          this.addWarning(commit, 'recommend_colorfill', msg)
        }
      }
    }
    return valid
  }

  /**
   * Validate if colorfill is the same as band color
   *
   * @returns {boolean}
   */
  validatePrintColorIsSameAsBandColor (commit) {
    let valid = true
    let category = 'colorfill_is_same_as_band'
    let isCustomColor = this.product.manifest.type === 'Custom Color'

    if (this.isColorfillTheSameAsTheBandColor() && !isCustomColor) {
      valid = false
      let msg = 'Your print color is the same as your band color. Please select a different print or band color.'
      this.addAlert(commit, category, msg)
    } else {
      this.removeAlert(commit, category)
    }

    return valid
  }

  validateMaxPrintColors (commit) {
    let valid = true
    let category = 'over_max_print_colors'

    // Check for max colors for printed bands
    if (this.isOverMaxPrintColors()) {
      console.log('is over')
      let msg = this.isOverMaxPrintColorsMessage()
      this.addAlert(commit, category, msg)
      valid = false
    } else {
      // console.log('is NOT over')
      this.removeAlert(commit, category)
    }

    return valid
  }

  validateMOQ (commit) {
    let valid = true
    let printStyle = this.getPrintStyle()
    let category = 'moq'

    this.removeAlert(commit, category)

    for (let row of this.customization.rows) {
      if (row.qty < printStyle.min_qty) {
        let msg = `You must order at least ${printStyle.min_qty} per item of ${printStyle.print_style.name}`
        this.addAlert(commit, category, msg)
        valid = false
      }
    }

    return valid
  }

  validateStartingNumber (commit) {
    let valid = true
    let category = 'starting_number'

    if (this.customization.tracking.number === true && !this.customization.tracking.startingNumber) {
      let msg = 'Please enter a valid starting number'
      this.addAlert(commit, category, msg)
      valid = false
    }

    if (valid) {
      this.removeAlert(commit, category)
    }

    return valid
  }

  validateTyvekQuantity (commit) {
    let valid = true
    let category = 'qty'

    if (this.customization.rows.length > 0) {
      let row = this.customization.rows[0]
      if (row.hasOwnProperty('qty')) {
        let qty = parseInt(row.qty)
        if (isNaN(qty)) {
          valid = false
        } else if (qty <= 0) {
          valid = false
        }
      } else {
        valid = false
      }
    }

    if (!valid) {
      let msg = 'Please enter a quantity'
      this.addAlert(commit, category, msg)
    } else {
      this.removeAlert(commit, category)
    }

    return valid
  }

  validatePrintColorsLocked (commit, currentRoute) {
    let currentStateName = currentRoute.name
    let category = 'printColorLocked'

    this.removeWarning(commit, category)

    if (['bandbuilder.silicone.text', 'bandbuilder.silicone.graphics'].indexOf(currentStateName) >= 0) {
      if (!this.printColor.required && this.hasMultipleItems()) {
        let msg = 'If you need to change print colors, do so on the "Size, Colors, & Qty" step.'
        this.addWarning(commit, category, msg)
      }
    }
  }

  /**
   * Display Warnings for any extra color fees
   *  NOTE: When this is validating it's always true since it only shows warnings.
   *
   * @returns {boolean}
   */
  isExtraColorFee (commit) {
    let category = 'extra_color_fee'

    this.removeWarning(commit, category)
    if (this.isPrinted()) {
      if (this.numberOfPrintColors() > 1) {
        let msg = 'If you need multiple colors, consider a Classic Debossed with Colorfill band.'
        this.addWarning(commit, category, msg)
      }
    } else if (this.isEmbossed()) {
      let numberOfPrintColors = this.numberOfPrintColors()
      let maxPrintColors = this.maxPrintColors()
      if (numberOfPrintColors > 0) {
        let msg = 'Print color setup is $20.'
        if (maxPrintColors > 1) {
          msg = 'Each print color setup is $20.'
        }
        this.addWarning(commit, category, msg)
      }
    }
  }

  validateAreaTextRequired (commit) {
    let valid = true
    let category = 'area_text_is_required'

    this.removeWarning(commit, category)

    let texts = this.getAllTexts(true)
    let area1TextExistsInManifest = _get(this.layout.manifest.manifest, 'areas.0.texts.0')

    if (!this.isBlank() && area1TextExistsInManifest) {
      if (texts.length <= 0) {
        valid = false
      }
    }

    if (!valid) {
      let msg = 'At least 1 phrase is required.'
      this.addAlert(commit, category, msg)
    } else {
      this.removeAlert(commit, category)
    }

    return valid
  }

  validateArea1TextRequired (commit) {
    let valid = true
    let category = 'area_1_text_is_required'

    this.removeWarning(commit, category)
    let texts = this.getAllTexts()
    let hasArea1Text = texts.find((text) => { return text.areaIndex === 0 && text.text })
    let hasArea2Text = texts.find((text) => { return text.areaIndex === 1 && text.text })

    let area1TextExistsInManifest = _get(this.layout.manifest.manifest, 'areas.0.texts.0')

    if (area1TextExistsInManifest) {
      if (hasArea2Text && !hasArea1Text) {
        valid = false
      }
    }

    if (!valid) {
      let msg = 'Side 1 phrase is required before adding Side 2 phrase'
      this.addAlert(commit, category, msg)
    } else {
      this.removeAlert(commit, category)
    }

    return valid
  }

  validateFontCharacters (phrase, fontName) {
    let invalidChars = []

    if (phrase) {
      // Check each character of the phrase
      for (const c of phrase) {
        let ordinal = c.charCodeAt(0)
        let font = _get(this.fontChars, fontName)
        if (font) {
          if (!font.includes(ordinal)) {
            invalidChars.push(c)
          }
        }
      }
    }

    return invalidChars
  }

  validateAllFontCharacters (commit, currentRoute) {
    let valid = true
    let category = 'validateFontCharacters'
    let notValidChars = []

    let texts = this.getAllTexts()
    for (const text of texts) {
      if (text.text) {
        notValidChars = this.validateFontCharacters(text.text, text.font)
        if (notValidChars.length) {
          valid = false
        }
      }
    }

    if (!valid) {
      let msg = `The following characters ("${notValidChars.join('", "')}") dont exist in your selected font`
      this.addAlert(commit, category, msg)
    } else {
      this.removeAlert(commit, category)
    }

    return valid
  }

  hasBothColorfillAndNoColorfill (commit) {
    let category = 'debossed_with_colorfill'

    this.removeWarning(commit, category)
    if (this.hasPrintColor() && this.hasAnyPrintWithNoColor()) {
      let msg = 'Heads up! You chose colorfill for one area, but not another.'
      this.addWarning(commit, category, msg)
    }
  }

  /**
   * Display Warnings for any extra sizes fees
   *  NOTE: When this is validating it's always true since it only shows warnings.
   *
   * @returns {boolean}
   */
  isExtraSizeFee (commit) {
    let category = 'embossed_size_fee'

    this.removeWarning(commit, category)
    if (this.isEmbossed()) {
      if (this.numberOfSizes() > 1) {
        let msg = 'First size is free. Each additional size is $40.'
        this.addWarning(commit, category, msg)
      }
    }
  }

  checkCompletion (commit, customstates, currentRoute, vm) {
    let valid = true
    let j, k

    // Run validators for each state
    // console.group('Validating states', states)
    let statesAffected = {}
    for (let i = 0; i < customstates.states.length; i++) {
      let state = customstates.states[i]

      // Only validate steps that are not hidden
      if (state.hidden) {
        continue
      }

      // Make sure the state has at least been visited by the customer first before validating
      if (state.name in customstates.visited) {
        let stateIsValid = true // eslint-disable-line no-unused-vars

        let scope = state.name.replace(/\./g, '')

        // Validate using vee-validate
        let bag = JSON.parse(JSON.stringify(vm.$validator.errors))
        // console.log('bag', bag)
        // console.log('bag.items.length', bag.items.length)

        if (bag.items.length > 0) {
          // console.log('Some errors')
          valid = stateIsValid = false
        }

        // console.log('validatorStateName', validatorStateName)
        // vm.$validator.validateAll(validatorStateName).then((result) => {
        //   console.log('result', result)
        //   // console.log('this.errors', this.errors)
        //   if (result) {
        //     console.log('all good')
        //   } else {
        //     console.log('not good')
        //     valid = stateIsValid = false
        //   }
        // })

        statesAffected[state.name] = true
        // console.log('Validate State '+state.name);
        for (j = 0; j < state.validators.length; j++) {
          let validator = state.validators[j]

          // Only validate if the current step is one of the validators specified states
          // if (validator.hasOwnProperty('onlyShowOnTheseStates')) {
          //     if (validator.onlyShowOnTheseStates) {
          //         if (validator.onlyShowOnTheseStates.indexOf(currentState) < 0) {
          //             continue
          //         }
          //     }
          // }

          let validatorIsValid = true
          // console.log('validator', validator)
          let validatorName = typeof validator === 'string' ? validator : validator.name
          let validatorStatesAffected = typeof validator === 'string' ? [state.name] : validator.statesAffected
          let isWarning = typeof validator === 'string' ? false : validator.isWarning
          // console.log('validatorStatesAffected', validatorStatesAffected)

          // Run the validator function
          if (!this[validatorName](commit, currentRoute)) {
            // console.log(validatorName, false)
            valid = stateIsValid = validatorIsValid = false
          }

          // If it's a warning there's no need to change the status of any states
          if (!isWarning) {
            for (k = 0; k < validatorStatesAffected.length; k++) {
              // Only change the state's status if the state has been edited
              if (validatorStatesAffected[k] in customstates.isDirty) {
                // Only change a state's value if it either doesn't exist yet, or it's value is true
                //  - Don't change a state's value if it's already false
                try {
                  if (statesAffected[validatorStatesAffected[k]]) {
                    statesAffected[validatorStatesAffected[k]] = validatorIsValid
                  }
                } catch (e) {
                  statesAffected[validatorStatesAffected[k]] = validatorIsValid
                }
              }
            }
          }
          // console.log('statesAffected', statesAffected)
        }
      } else if (i === 0) {
        statesAffected[state.name] = true
      }
    }

    // console.log('Final statesAffected', statesAffected)
    for (let name in statesAffected) {
      if (statesAffected.hasOwnProperty(name)) {
        // Commit to module "customstates"
        commit('customstates/setCompleted', { routeName: name, value: statesAffected[name] }, { root: true })
      }
    }

    // console.groupEnd()

    return valid
  }

  addRow (row = null) {
    let color1, color2, color3, colorFill, variant, qty
    let newRowIndex = this.customization.rows.length
    let lastRow = 0

    if (!row) {
      lastRow = this.customization.rows.length - 1
      color1 = _clone(this.customization.rows[lastRow].color1)
      color2 = this.product.manifest.colorContainers.color_1 ? _clone(this.customization.rows[lastRow].color2) : null
      color3 = this.product.manifest.colorContainers.color_2 ? _clone(this.customization.rows[lastRow].color3) : null
      colorFill = _clone(this.customization.rows[lastRow].colorFill)
      variant = _clone(this.customization.rows[lastRow].variant)
      qty = this.customization.rows[lastRow].qty

      row = {
        color1,
        color2,
        color3,
        colorFill,
        qty,
        variant
      }
    }

    // Update paths with the new row index
    // Fix for RBI-WEBSITE-3KR: Add defensive checks for _path properties
    const updateColorPath = (colorObj, propertyName) => {
      if (!colorObj) return
      
      if (colorObj._path) {
        const match = colorObj._path.match(/rows\.([0-9]+)/)
        if (match && match[1]) {
          const search = `rows.${match[1]}`
          const replace = `rows.${newRowIndex}`
          colorObj._path = colorObj._path.replace(search, replace)
        } else {
          colorObj._path = `customization.rows.${newRowIndex}.${propertyName}`
        }
      } else {
        colorObj._path = `customization.rows.${newRowIndex}.${propertyName}`
      }
    }

    updateColorPath(row.color1, 'color1')
    updateColorPath(row.color2, 'color2')
    updateColorPath(row.color3, 'color3')
    updateColorPath(row.colorFill, 'colorFill')

    row.bandType = this.product.name

    let totalRows = this.customization.rows.push(row)

    this.customization.selected = totalRows - 1
  }

  removeRow (rowIndex) {
    this.customization.rows.splice(rowIndex, 1)
    if (this.customization.rows.length === 0) {
      this.customization.rows.push(this.getDefaultRow())
    }
  }

  getZonePrintColor (zone) {
    return _get(zone, 'colorFill', false)
  }

  zoneHasPrintColor (zone) {
    return _get(zone, 'colorFill.id', false)
  }

  selectedPrintColorsAreSameAsThisOne(colorId) {
    let selectedPrintColors = this.getSelectedPrintColors(true)
    for (let colorFill of selectedPrintColors) {
      let colorFillId = _get(colorFill, 'id')
      if (parseInt(colorFillId) !== parseInt(colorId)) {
        return false
      }
    }

    return true
  }

  itemsPrintColorsAreSame() {
    let lastColorFillId = null
    if (this.customization.rows.length > 1) {
      for (let i=0; i < this.customization.rows.length; i++) {
        let row = this.customization.rows[i]
        let colorFillId = _get(row, 'colorFill.id')
        if (colorFillId !== lastColorFillId && i !== 0) {
          return false
        }
      }
    }

    return true
  }

  hasAllTheSamePrintColors () {
    let manifest = this.layout.manifest.manifest
    let last

    let checkObjPrintColor = function (manifestObj, obj) {
      let manifestColorFill = _get(manifestObj, 'colorFill')
      if (manifestColorFill) {
        let objPrintColor = _get(obj, 'colorFill.id')
        if (typeof last !== 'undefined') {
          if (last !== objPrintColor) {
            return false
          }
        }
        last = objPrintColor
      }
      return true
    }

    if (this.template !== 'free') {
      for (let i = 0; i < manifest.areas.length; i++) {
        let manifestArea = manifest.areas[i]
        if (manifestArea.hasOwnProperty('texts')) {
          for (let j = 0; j < manifestArea.texts.length; j++) {
            let manifestText = manifestArea.texts[j]
            let textObj = this.getTextObj(i, j)
            let actualText = _get(textObj, 'text')
            if (actualText) {
              if (!checkObjPrintColor(manifestText, textObj)) {
                return false
              }
            }

            let manifestPrefixGraphic = _get(manifestText, 'prefixGraphic')
            let textPrefixGraphic = _get(textObj, 'prefixGraphic')
            let textPrefixGraphicImage = _get(textPrefixGraphic, 'image')
            if (manifestPrefixGraphic && textPrefixGraphicImage) {
              if (!checkObjPrintColor(manifestPrefixGraphic, textPrefixGraphic)) {
                return false
              }
            }

            let manifestSuffixGraphic = _get(manifestText, 'suffixGraphic')
            let textSuffixGraphic = _get(textObj, 'suffixGraphic')
            let textSuffixGraphicImage = _get(textSuffixGraphic, 'image')
            if (manifestSuffixGraphic && textSuffixGraphicImage) {
              if (!checkObjPrintColor(manifestSuffixGraphic, textSuffixGraphic)) {
                return false
              }
            }
          }
        }

        if (manifestArea.hasOwnProperty('graphics')) {
          for (let j = 0; j < manifestArea.graphics.length; j++) {
            let manifestGraphic = manifestArea.graphics[j]
            let graphicObj = this.getFixedGraphicAt(i, j)
            let graphicObjImage = _get(graphicObj, 'image')

            if (graphicObjImage) {
              if (!checkObjPrintColor(manifestGraphic, graphicObj)) {
                return false
              }
            }
          }
        }
      }
    }

    return true
  }

  addAlert (commit, category, msg) {
    let payload = { category, msg }
    commit('alerts/add', payload, {root: true})
  }

  addWarning (commit, category, msg) {
    let payload = { category, msg }
    commit('warnings/add', payload, {root: true})
  }

  removeAlert (commit, category) {
    commit('alerts/remove', category, { root: true })
  }

  removeWarning (commit, category) {
    commit('warnings/remove', category, { root: true })
  }

  lookAtGlobalColorFill () {
    return this.hasMultipleItems() && (this.numberOfPrintColors() < 2)
  }

  getAreasPostData () {
    let areas = []

    this.customization.areas.forEach(area => areas.push(area.getPostData()))

    return areas
  }

  getDataForSelectedRow (defaultVariant = false) {
    let selected = this.customization.selected
    let printStyle = this.getPrintStyle()
    let data = {
      'notes': this.customization.notes,
      'product_print_style_id': printStyle.id
    }

    if (this.isTyvek()) {
      data.tracking = this.customization.tracking
      if (this.customization.hasOwnProperty('graphics')) {
        data.graphics = this.customization.graphics
      }
      if (this.customization.hasOwnProperty('background')) {
        data.background = this.customization.background
      }
    }

    for (let i = 0; i < this.customization.rows.length; i++) {
      if (selected) {
        if (selected !== i) {
          continue
        }
      }

      let row = this.customization.rows[i]
      // let rowColorFillId = _get(row, 'colorFill.id')
      let rowColorFill = _get(row, 'colorFill')
      // console.log('rowColorFill', rowColorFill)
      // let rowHasColorFill = !!rowColorFillId

      // Make sure the "areas" are populated correctly for this item
      if (this.lookAtGlobalColorFill()) {
        store.dispatch('customband/setAllPrintColors', rowColorFill)
      }

      data.color1 = row.color1
      if (!_isEmpty(this.product.manifest.colorContainers) && this.product.manifest.type !== 'Dual Layer') {  // If we have more than one color, always default to the first.
        data.color1 = this.customization.rows[0].color1
        data.color2 = this.customization.rows[0].color2
        if (this.product.manifest.colorContainers.color_2) {
          data.color3 = this.customization.rows[0].color3
        }
      }

      // If the print color is required, then we also assume that we don't charge colorfill fee
      data.printColorIsRequired = this.printColor.required

      let qty = parseInt(row.qty)
      if (isNaN(qty)) {
        qty = 1
      }

      let variant = defaultVariant
      if (row.hasOwnProperty('variant')) {
        variant = row.variant
      }

      let allPrintColors = this.listOfPrintColors()
      let numberOfPrintColors = allPrintColors.length
      // console.log('numberOfPrintColors', numberOfPrintColors)

      // Make sure the colorFill properties in the areas property are all set to their correct colorfill
      if (numberOfPrintColors === 0) {
        if (this.hasMultipleItems()) {
          // console.log('Setting all print colors to: empty')
          store.dispatch('customband/setAllPrintColors', {})
        }
      } else if (numberOfPrintColors === 1) {
        if (this.hasMultipleItems()) {
          // console.log('Setting all print colors to:', rowColorFill.name)
          store.dispatch('customband/setAllPrintColors', rowColorFill)
        }
      }

      // console.log('this.listOfPrintColors()', _get(this.listOfPrintColors(), '0.name'))
      data.areas = _cloneDeep(JSON.parse(JSON.stringify(this.getAreasPostData())))

      // console.log('data.areas', data.areas)
    }

    return data
  }

  getPostData (images = false, selected = false, defaultVariant = false) {
    let printStyle = this.getPrintStyle()
    let data = {
      'notes': this.customization.notes,
      'product_print_style_id': printStyle.id
    }

    if (this.isTyvek()) {
      data.tracking = this.customization.tracking
      if (this.customization.hasOwnProperty('graphics')) {
        data.graphics = this.customization.graphics
      }
      if (this.customization.hasOwnProperty('background')) {
        data.background = this.customization.background
      }
    }
    let postData = {}

    for (let i = 0; i < this.customization.rows.length; i++) {
      if (selected) {
        if (selected !== i) {
          continue
        }
      }

      let row = this.customization.rows[i]
      // let rowColorFillId = _get(row, 'colorFill.id')
      let rowColorFill = _get(row, 'colorFill')
      // console.log('rowColorFill', rowColorFill)
      // let rowHasColorFill = !!rowColorFillId

      // Make sure the "areas" are populated correctly for this item
      if (this.lookAtGlobalColorFill()) {
        store.dispatch('customband/setAllPrintColors', rowColorFill)
      }

      data.color1 = row.color1
      if (!_isEmpty(this.product.manifest.colorContainers) && this.product.manifest.type !== 'Dual Layer') {  // If we have more than one color, always default to the first.
        data.color1 = this.customization.rows[0].color1
        data.color2 = this.customization.rows[0].color2
        if (this.product.manifest.colorContainers.color_2) {
          data.color3 = this.customization.rows[0].color3
        }
      }

      // data.colorFill = row.colorFill ? row.colorFill.hex_code : 'ffffff'
      // Gets the right screen shot and attaches it to the data.
      // let thumb = _.find(images, function(img) {
      //   let hex = row.colorFill ? row.colorFill.hex_code : 'ffffff'
      //   return img.colorFill === hex
      // })
      // data.thumbnail = thumb.image
      if (this.showBuilder && images) {
        // data.thumbnail = row.image
        data.thumbnail = images
      }

      // If the print color is required, then we also assume that we don't charge colorfill fee
      data.printColorIsRequired = this.printColor.required

      let qty = parseInt(row.qty)
      if (isNaN(qty)) {
        qty = 1
      }

      let variant = defaultVariant
      if (row.hasOwnProperty('variant')) {
        variant = row.variant
      }

      let allPrintColors = this.listOfPrintColors()
      let numberOfPrintColors = allPrintColors.length
      // console.log('numberOfPrintColors', numberOfPrintColors)

      // Make sure the colorFill properties in the areas property are all set to their correct colorfill
      if (numberOfPrintColors === 0) {
        if (this.hasMultipleItems()) {
          // console.log('Setting all print colors to: empty')
          store.dispatch('customband/setAllPrintColors', {})
        }
      } else if (numberOfPrintColors === 1) {
        if (this.hasMultipleItems()) {
          // console.log('Setting all print colors to:', rowColorFill.name)
          store.dispatch('customband/setAllPrintColors', rowColorFill)
        }
      }

      // console.log('this.listOfPrintColors()', _get(this.listOfPrintColors(), '0.name'))
      data.areas = _cloneDeep(JSON.parse(JSON.stringify(this.getAreasPostData())))

      // console.log('data.areas', data.areas)

      postData['form-' + i + '-quantity'] = parseInt(qty)
      postData['form-' + i + '-product_variant'] = variant.id
      postData['form-' + i + '-data'] = JSON.stringify(data)
      postData['form-' + i + '-layout_id'] = this.layout.id
    }
    // $('#id_form-TOTAL_FORMS').val(this.customization.rows.length)
    postData['form-TOTAL_FORMS'] = this.customization.rows.length
    postData['form-INITIAL_FORMS'] = 0
    postData['form-MIN_NUM_FORMS'] = 0
    postData['form-MAX_NUM_FORMS'] = 1000

    return postData
  }

  getStates () {
    return this.layout.manifest.states
  }

  /**
   * Populate the areas with data
   *
   * @param data - If no data given then it will use defaults from the manifest
   */
  populateAreas (data = null) {
    // console.log('data', data)

    let defaultFont = this.getDefaultFont()

    // Initialize the areas
    if (this.template !== 'free') {
      // Reset the areas in-case there is already some existing data
      this.customization.areas = []
      let numOfAreas = this.product.manifest.areas.length
      if (numOfAreas > 0) {
        for (let i = 0; i < numOfAreas; i++) {
          // Setup the defaults
          let defaults = {
            printColor: this.getDefaultPrintColor(),
            font: defaultFont
          }

          // Setup the config obj for the area
          let areaConfig = {
            manifest: this.product.manifest.areas[i],
            defaults,
            areaObj: Object.assign({
              areaIndex: i
            }, this.product.manifest.areas[i])
          }

          let areaObj = _get(data, `areas.${i}`, null)
          if (areaObj) {
            // Setup the config obj for the area
            let areaIndex = _get(areaObj, 'areaIndex')
            /* eslint-disable camelcase */
            let areas_index = _get(areaObj, 'areas_index')
            let aIndex = areaIndex || areas_index
            if (_isUndefined(aIndex)) {
              areaObj.areaIndex = i
            }
            areaConfig.areaObj = areaObj
          }

          let area = new Area(areaConfig)
          this.customization.areas.push(area)
        }
      }
    } else {
      this.customization = this.tyvekCustomization
    }
  }

  /**
   * Checks if the new Print Style allows multiple print colors or not.
   *      NOTE: This will be used if we ever differentiate print colors (global or multiple) print styles in the manifest
   *
   * @param newPrintStyle
   * @returns {Array}
   */
  checkPrintColorPositionsInNewPrintStyle (newPrintStyle) {
    let changes = []
    return changes
  }

  /**
   * Checks if the currently selected colors exist in the newly selected Print Style
   *
   * @param newPrintStyle
   * @returns {Array}
   */
  checkCurrentColorsAreInNewPrintStyle (newPrintStyle) {
    let changes = []
    let newProductColors = newPrintStyle.product_colors ? newPrintStyle.product_colors.colors : []
    let newPrintColors = newPrintStyle.print_colors ? newPrintStyle.print_colors.colors : []

    let allColors = ['color1', 'color2', 'color3']
    let defaultBandColor = this.getDefaultProductColors()
    let defaultPrintColor = this.getDefaultPrintColor()
    let textColorFill

    let numberOfRows = this.customization.rows.length
    for (let i = 0; i < numberOfRows; i++) {
      let j
      let row = this.customization.rows[i]

      // Check all 3 band colors
      for (j = 0; j < allColors.length; j++) {
        let colorIndex = allColors[j]
        let currentColor = row[colorIndex]
        if (currentColor) {
          // console.log(colorIndex + ':', row[colorIndex]);
          // console.log(newPrintStyle.product_colors.colors);

          /* jshint loopfunc: true */
          /* See: http://stackoverflow.com/questions/13082302/js-hint-dont-make-functions-within-a-loop */
          if (newProductColors.findIndex(function (ele) { return ele.id === currentColor.id }) === -1) {
            // console.log('color' + i + ' did not exist:', currentColor);
            if (typeof defaultBandColor[i] !== 'undefined') {
              // console.log('Color did not exist. Setting to default:', defaultBandColor[i]);
              changes.push({
                '_path': `customization.rows.${i}.${colorIndex}`,
                value: defaultBandColor[i]
              })
              // row[colorIndex] = defaultBandColor[i]
            }
          }
        }
      }

      // Check the global color fill
      let rowPrintColor = this.getZonePrintColor(row)
      if (rowPrintColor) {
        if (rowPrintColor.hasOwnProperty('id')) {
          if (rowPrintColor.id) {
            // If the current global print color doesn't exist in the new set of print colors then set it to the default
            if (newPrintColors.findIndex(function (ele) { return ele.id === row.colorFill.id }) === -1) {
              changes.push({
                '_path': `customization.rows.${i}.colorFill`,
                value: defaultPrintColor
              })
              // row.colorFill = defaultPrintColor
            }
          }
        }
      }

      // Check all the element specific color fills
      for (let l = 0; l < this.customization.areas.length; l++) {
        if (this.customization.areas[l].hasOwnProperty('texts')) {
          for (j = 0; j < this.customization.areas[l].texts.length; j++) {
            let text = this.customization.areas[l].texts[j]
            if (text.hasOwnProperty('colorFill')) {
              if (text.colorFill) {
                if (text.colorFill.id) {
                  if (newPrintColors.findIndex(function (ele) {
                    return ele.id === text.colorFill.id
                  }) === -1) {
                    // console.log('setting text to:', defaultPrintColor);
                    changes.push({
                      '_path': text.colorFill._path,
                      'value': defaultPrintColor
                    })
                    // text.colorFill = defaultPrintColor
                  }
                }
              }
            }
            // See if a print color is required
            if (newPrintStyle.print_style.code === 'printed') {
              textColorFill = null
              if (this.zoneHasPrintColor(text)) {
                textColorFill = text.colorFill
              } else {
                textColorFill = defaultPrintColor
              }
              changes.push({
                '_path': text.colorFill._path,
                'value': textColorFill
              })
              // text.colorFill = !textColorFill ? defaultPrintColor : textColorFill
              // console.log('setting text.colorfill to:', text.colorFill);
            }
            // Check the relational graphics
            for (let textGraphicProperty of this.textGraphicProperties) {
              let colorFill = _get(text, `${textGraphicProperty}.colorFill`, null)
              let colorFillId = _get(colorFill, 'id', null)
              if (colorFillId) {
                let didntFindColorFillIdInNewPrintColors = newPrintColors.findIndex(ele => {
                  return ele.id === colorFillId
                }) === -1
                if (didntFindColorFillIdInNewPrintColors) {
                  changes.push({
                    '_path': text[textGraphicProperty].colorFill._path,
                    'value': defaultPrintColor
                  })
                  // text[textGraphicProperty].colorFill = defaultPrintColor
                }
              }

              // See if a print color is required
              if (newPrintStyle.print_style.code === 'printed') {
                if (colorFillId) {
                  changes.push({
                    '_path': text[textGraphicProperty].colorFill._path,
                    'value': colorFill
                  })
                  // text[textGraphicProperty].colorFill = colorFill
                } else {
                  changes.push({
                    '_path': text[textGraphicProperty].colorFill._path,
                    'value': defaultPrintColor
                  })
                  // text[textGraphicProperty].colorFill = defaultPrintColor
                }
              }
            }
          }
        }

        // Check the fixed graphics
        if (this.customization.areas[l].hasOwnProperty('graphics')) {
          for (let z = 0; z < this.customization.areas[l].graphics.length; z++) {
            let graphic = this.customization.areas[l].graphics[z]
            let colorFill = _get(graphic, 'colorFill', null)
            let colorFillId = _get(colorFill, 'id', null)
            if (graphic.image) {
              if (graphic.hasOwnProperty('colorFill')) {
                if (graphic.colorFill) {
                  if (graphic.colorFill.id) {
                    if (newPrintColors.findIndex(function (ele) { return ele.id === graphic.colorFill.id }) === -1) {
                      changes.push({
                        '_path': graphic.colorFill._path,
                        'value': defaultPrintColor
                      })
                      // graphic.colorFill = defaultPrintColor
                    }
                  }
                }
              }

              // See if a print color is required
              if (newPrintStyle.print_style.code === 'printed') {
                if (colorFillId) {
                  changes.push({
                    '_path': graphic.colorFill._path,
                    'value': colorFill
                  })
                  // graphic.colorFill = colorFill
                } else {
                  changes.push({
                    '_path': graphic.colorFill._path,
                    'value': defaultPrintColor
                  })
                  // graphic.colorFill = defaultPrintColor
                }
              }
            }
          }
        }
      }
    }

    return changes
  }

  /**
   * Checks if the current selected fonts exist in the new Print Style
   *
   * @param newPrintStyle
   * @returns {Array}
   */
  checkCurrentFontsAreInNewPrintStyle (newPrintStyle) {
    let changes = []
    let newFonts = newPrintStyle.font_group ? newPrintStyle.font_group.fonts : []
    let newDefaultFont = this.getDefaultFont(newPrintStyle)

    let numberOfRows = this.customization.rows.length
    for (let i = 0; i < numberOfRows; i++) {
      // Check all the element specific fonts
      /* jshint loopfunc: true */
      for (let l = 0; l < this.customization.areas.length; l++) {
        if (this.customization.areas[l].hasOwnProperty('texts')) {
          for (let j = 0; j < this.customization.areas[l].texts.length; j++) {
            let text = this.customization.areas[l].texts[j]
            if (text.hasOwnProperty('font')) {
              if (text.font) {
                if (newFonts.findIndex(function (ele) { return ele.name === text.font }) === -1) {
                  changes.push({
                    obj: text,
                    fontName: newDefaultFont
                  })
                  // text.font = newDefaultFont
                }
              }
            }
          }
        }
      }
    }
    return changes
  }
}
